import { Box, Skeleton } from "@dehub/theme";
import classes from "../business.module.css";

type Props = Readonly<{
  /** Number of single-line fields (two per row) before the tall field. */
  fields?: number;
}>;

/** A form-shaped placeholder shown while an existing record loads (instead of a spinner over blank inputs). */
export function FormSkeleton({ fields = 2 }: Props) {
  return (
    <Box className={classes.skeletonStack} aria-busy="true" aria-live="polite">
      <Skeleton height={14} width={180} />
      <Box className={classes.skeletonGrid}>
        {Array.from({ length: fields }, (_, index) => (
          <Box key={index}>
            <Skeleton height={14} width={120} mb={6} />
            <Skeleton height={38} radius="md" />
          </Box>
        ))}
      </Box>
      <Box>
        <Skeleton height={14} width={160} mb={6} />
        <Skeleton height={84} radius="md" />
      </Box>
      <Skeleton height={14} width={220} />
      <Skeleton height={92} radius="lg" />
    </Box>
  );
}
